import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, ButtonGroup, Dropdown, DropdownButton, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import Labels from '../Labels';
import Parsers from '../Tools/Parsers';
import Container from '../components/Container';
import ErrorComponent from '../components/ErrorComponent';
import PageComponent from '../components/PageComponent';
import Connection from '../config/Connection';
import '../styles/generics.css';
import './Home.js.css';

export default class ProgramPage extends PageComponent {

  static PageInfo = {
    // path: "/Program", 
    path: "/Program/",
    name: "menu.programs",
    permission: { "PROGRAM_LIST": true },
    icon: "trophy"
  }

  constructor(props) {
    super(props);
    this.state = {
      filter: []
    };
    this.state.data = [];
    this.state.modalError = null;
    this.state.loading = false;
    this.state.isModalVisible = null;
    this.state.modalInitializing = false;
    this.state.modalLoading = false;
  }

  componentDidMount() {
    const lastYear = new Date().getFullYear();
    this.downloadAllData([`${lastYear}/${lastYear + 1}`])

    Connection.Secure(Connection.service + 'ProgramGetLastYear')
      .then((response) => {
        console.log("response", response)
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            console.log("data", data)
            const startYear = data.year;
            const currentYear = new Date().getFullYear();
            const filter = [];

            for (let year = startYear; year <= currentYear; year++) {
              filter.push({
                value: `${year}/${year + 1}`,
                label: `${year}/${year + 1}`
              });
            }

            const lastFilter = filter[filter.length - 1];

            this.setState({ filter: filter, lastFilter: lastFilter });
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  extractFirstNumber = arr => {
    return arr.map(item => item.split('/')[0]);
  };

  downloadAllData(harvestDate) {
    if (harvestDate.length > 0) {
      this.setState({ loading: true });

      const extractedNumbers = this.extractFirstNumber(harvestDate);
      const data = JSON.stringify({ years: extractedNumbers });

      Connection.Secure(Connection.service + 'ProgramGetAll', {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: data
      })
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.setState({ error: null, loading: false, data: data });
            });
          else this.setState({ error: response, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error, loading: false });
        }).finally(() => {
          this.setState({ loading: false });
        });
    }
  }

  downloadReport(target) {
    console.log(this.state.harvestDate)
    const extractedNumbers = this.extractFirstNumber(this.state.harvestDate);
    const data = JSON.stringify({ years: extractedNumbers });

    var f = "all_" + target + ".xlsx";
    this.setState({ isModalVisible: "downloading", modalInitializing: true });
    Connection.Secure(Connection.service + (
      target == "program" ? 'Report/Program/All/' + f :
        target == "qawardf" ? 'Report/QualitativeAwardInvoice/All/' + f :
          target == "qaward" ? "Report/QualitativeAward/All/" + f :
            target == "fresult" ? "Report/FranchiseeeResult/All/" + f : ""), {
      "method": "POST",
      "headers": {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: data
    })
      .then(res => res.blob())
      .then(blob => {
        this.setState({ isModalVisible: null });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = f;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again 
      });
  }

  render() {
    return (
      <Container context={this.constructor}>
        {
          this.state.error != null ? <ErrorComponent error={this.state.error} /> :
            <div className="generics_panels" style={{ flexDirection: "column" }}>
              <div>
                <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span>{Labels.GetLabel(this.constructor.PageInfo.name)}</span></div>
                <div className="generics_label_select">{Labels.GetLabel("generic.status2")}</div>
                <Select
                  isMulti
                  options={this.state.filter}
                  onChange={x => {
                    var data = x.map(option => option.value)
                    this.setState({ harvestDate: data })
                    this.downloadAllData(data)
                  }}
                />
                <div className="generics_description_select">*{Labels.GetLabel("generic.allstates2")}</div>
              </div>
              <div>
                <div className="generics_panels_header"><FontAwesomeIcon icon="list" /> <span>{Labels.GetLabel("clients.results")} ({Array.isArray(this.state.data) ? this.state.data.length : 0})</span></div>
                {
                  this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> : (
                    !Array.isArray(this.state.data) || this.state.data.length == 0 ?
                      <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div>
                      :
                      this.state.data.map((item) =>
                        <Link to={"/Program/Detail/" + item.program.id + (Parsers.parsePermission2(["PROGRAM_ACCESS"]) ? "" : "/Goals/")} className="generics_listing_item" >
                          <FontAwesomeIcon icon={Parsers.GetStatusIcon(item.program.programStatusElement[0].programStatus.keyConstant)} className="generics_listing_item_icon" style={{
                            opacity: 1, color: Parsers.GetStatusColor(item.program.programStatusElement[0].programStatus.keyConstant)
                          }} />
                          <div className="generics_listing_content" >
                            <div className="generics_listing_item_title" style={{
                              color: Parsers.GetStatusColor(item.program.programStatusElement[0].programStatus.keyConstant)
                            }}>{item.program.label}</div>
                            <div className="generics_listing_item_description"  >{item.program.brand.label} -  {Labels.GetLabel(item.program.fkClientType == null ? 'generic.all' : 'CLIENT_TYPE.' + item.program.fkClientType)}</div>
                            <div style={{ textAlign: "right" }}>{item.program.dtProgramStart == null || item.program.dtProgramEnd == null ? "Sem Cronograma" : Parsers.parseDate(item.program.dtProgramStart, "time") + " - " + Parsers.parseDate(item.program.dtProgramEnd, "time")}</div>
                            <div>
                              <div className="generics_listing_item_description" style={{
                                float: "right"
                              }}>{Labels.GetLabel("STATUS_PROGRAM_3." + item.program.programStatusElement[0].programStatus.keyConstant)}</div>
                            </div>
                            <div style={{ clear: "both" }}></div>
                          </div>
                        </Link>
                      )
                  )
                }
              </div>
              <div style={{ flex: 1 }}></div>
              <div className="generics_actionbar">
                <div>
                  <DropdownButton
                    as={ButtonGroup}
                    key="up"
                    drop="up"
                    variant="primary" style={{ marginRight: 10 }}
                    title={Labels.GetLabel("program.report")}
                    onSelect={(t) => {
                      switch (t) {
                        case "program":
                        case "qaward":
                        case "qawardf":
                        case "fresult":
                          this.downloadReport(t);
                          break;
                      }
                    }}
                  >
                    {!Parsers.parsePermission2(["PROGRAM_REPORT_STATUS"]) ? null :
                      <Dropdown.Item eventKey="program" >{Labels.GetLabel("menu.programs")}</Dropdown.Item>
                    }
                    {!Parsers.parsePermission2(["PROGRAM_REPORT_QA"]) ? null :
                      <Dropdown.Item eventKey="qaward" >{Labels.GetLabel("program.qualitativeaward")}</Dropdown.Item>
                    }
                    {!Parsers.parsePermission2(["PROGRAM_REPORT_QA"]) ? null :
                      <Dropdown.Item eventKey="qawardf" >{Labels.GetLabel("program.qualitativeawardf")}</Dropdown.Item>
                    }
                    {!Parsers.parsePermission2(["PROGRAM_REPORT_QA"]) ? null :
                      <Dropdown.Item eventKey="fresult" >{Labels.GetLabel("program.franchiseeresults")}</Dropdown.Item>
                    }

                  </DropdownButton>
                </div>
                <div style={{ flex: 1 }}></div>
                <div style={{ clear: "both" }}></div>
              </div>

              <Modal
                className={this.state.modalLoading == true ? "modal-loading" : ""}
                onHide={() => { }} show={this.state.isModalVisible != null}
              // onHide={handleClose}
              >
                <div>
                  {
                    this.state.modalInitializing == true || this.state.data == null || this.state.isModalVisible == null ?
                      <div>
                        {Labels.GetLabel("adminstategroup.saving")}
                      </div>
                      :
                      <div>
                        <Modal.Header>
                          <Modal.Title>{Labels.GetLabel("program.alterstatus")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {Labels.GetLabel("clientsnew.confirmation")}
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                            {Labels.GetLabel("adminstategroup.closebtn")}
                          </Button>
                          <Button variant="primary" onClick={() => this.addNew()}>
                            {Labels.GetLabel("adminstategroup.savebtn")}
                          </Button>
                        </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                      </div>
                  }
                </div>
              </Modal>
            </div>
        }
      </Container >
    );
  }
}